import { FiveZeroZero } from "./FiveZeroZero.component";

export default FiveZeroZero;
